import { Button, makeStyles, useTheme } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles((theme) => ({
	outlinedButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		borderColor: theme.palette.secondary.main,
		backgroundColor: ({ backgroundColor }) => backgroundColor,
		'&:hover': {
			background: ({ backgroundColor, variant }) => (variant !== 'text' ? backgroundColor : 'none')
		},
		padding: ({ startIcon }) => (startIcon ? '7px 40px 8px 24px' : 'auto'),
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: ({ variant }) => (variant === 'text' ? 3 : 16)
			},
			'& > span:nth-child(2)': {
				paddingTop: 1
			}
		}
	}
}))

export const MainButton = ({
	label,
	startIcon,
	onClick,
	variant = 'outlined',
	color = 'secondary',
	disabled = false,
	backgroundColor = null,
	style = {},
	size = 'large',
	disableElevation = false
}) => {
	const theme = useTheme()
	const classes = useStyles({
		backgroundColor: backgroundColor
			? backgroundColor
			: variant === 'contained'
			? theme.palette.secondary.main
			: undefined,
		variant,
		startIcon
	})

	return (
		<Button
			style={style}
			disableElevation={disableElevation}
			variant={variant}
			className={classes.outlinedButton}
			color={color}
			startIcon={startIcon}
			size={size}
			onClick={onClick}
			disabled={disabled}>
			<span>{label}</span>
		</Button>
	)
}
